import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraLink, SpecraOverlayDrawer, SpecraText } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { renderRouterLink } from '../../../../lib/renderRouterLink';
import { PursuitClaim } from '../hearsay/PursuitHearsayBlock';
/** §3.2 href of a claim's RELEVANT_TO context (labels come from REG, readable ones only). */ export function contextHref(link) {
    switch(link.targetKind){
        case 'PURSUIT':
            return `/capture/${link.targetId}`;
        case 'RFI':
            return `/rfi-response/${link.targetId}`;
        default:
            return '';
    }
}
/**
 * GRW-20 item 9: every claim ABOUT a competitor's company, from every
 * context the viewer may see (REG filters). A context REG does not name for
 * the viewer (blank label) is omitted, never counted.
 */ export function CompetitorHearsayDrawer({ companyName, claims, open, onOpenChange, onChanged }) {
    return /*#__PURE__*/ _jsx(SpecraOverlayDrawer, {
        open: open,
        onOpenChange: onOpenChange,
        title: `Hearsay about ${companyName}`,
        description: "Paraphrased notes about this company, from everything you can see.",
        testId: Testids.pursuitCompetitors.hearsayDrawer,
        width: "md",
        scrollBody: true,
        children: /*#__PURE__*/ _jsx("div", {
            className: "space-y-4",
            children: claims.map((claim)=>{
                const contexts = claim.links.filter((l)=>l.linkRole === 'RELEVANT_TO' && l.label && contextHref(l));
                return /*#__PURE__*/ _jsxs("div", {
                    className: "space-y-1",
                    children: [
                        /*#__PURE__*/ _jsx(PursuitClaim, {
                            claim: claim,
                            onChanged: onChanged
                        }),
                        contexts.length > 0 && /*#__PURE__*/ _jsx(SpecraText, {
                            as: "div",
                            size: "meta",
                            tone: "muted",
                            children: contexts.map((l, i)=>/*#__PURE__*/ _jsxs("span", {
                                    children: [
                                        i > 0 ? ' · ' : '',
                                        /*#__PURE__*/ _jsx(SpecraLink, {
                                            "data-testid": Testids.pursuitCompetitors.hearsayContextLink,
                                            href: contextHref(l),
                                            renderLink: renderRouterLink,
                                            children: l.label
                                        })
                                    ]
                                }, `${l.targetKind}:${l.targetId}`))
                        })
                    ]
                }, claim.id);
            })
        })
    });
}
